import React from 'react';
import { UnifiedCartButton } from './CartButton';
import { LegacyCartButton } from './CartButton';

export const Container = props => {
  if (props.model.isUnifiedCart) {
    return (
      <div>
        <UnifiedCartButton {...props} uuid={props.model.userUuid} />
      </div>
    );
  }

  return (
    <div>
      <LegacyCartButton {...props} uuid={props.model.userUuid} />
    </div>
  );
};
